import { atom } from "recoil";

export const onBoardingSteps = atom<number>({
  key: "onBoardingSteps",
  default: 1,
});
